import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const AccessibilitySolid = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipPath="url(#accessibility-solid-clip)"><path d="M7.99996 0.667069C6.54957 0.667069 5.13174 1.09716 3.92578 1.90296C2.71982 2.70875 1.77989 3.85407 1.22485 5.19406C0.669803 6.53405 0.524579 8.00854 0.807537 9.43106C1.0905 10.8536 1.78893 12.1603 2.81451 13.1859C3.8401 14.2114 5.14677 14.9099 6.5693 15.1928C7.99183 15.4758 9.46632 15.3306 10.8063 14.7755C12.1463 14.2205 13.2916 13.2805 14.0974 12.0746C14.9032 10.8686 15.3333 9.4508 15.3333 8.0004C15.3377 7.03614 15.151 6.08056 14.7841 5.18884C14.4171 4.29713 13.8771 3.48696 13.1953 2.80511C12.5134 2.12327 11.7032 1.58327 10.8115 1.2163C9.91981 0.849325 8.96422 0.662655 7.99996 0.667069ZM7.99996 3.33374C8.19774 3.33374 8.39108 3.39238 8.55553 3.50227C8.71998 3.61215 8.84815 3.76833 8.92384 3.95105C8.99953 4.13378 9.01933 4.33484 8.98075 4.52883C8.94216 4.72281 8.84692 4.90099 8.70707 5.04084C8.56722 5.18069 8.38903 5.27594 8.19505 5.31452C8.00107 5.35311 7.8 5.3333 7.61728 5.25761C7.43455 5.18193 7.27837 5.05375 7.16849 4.88931C7.05861 4.72486 6.99996 4.53152 6.99996 4.33374C6.99531 4.20116 7.01799 4.06904 7.06659 3.94561C7.1152 3.82218 7.18869 3.71007 7.2825 3.61627C7.3763 3.52247 7.48841 3.44897 7.61184 3.40037C7.73527 3.35176 7.86739 3.32908 7.99996 3.33374ZM11.6666 7.0004H9.3333V8.6004L9.99996 11.8671C10.03 12.0433 9.99154 12.2244 9.89237 12.3731C9.7932 12.5219 9.64087 12.627 9.46663 12.6671H9.3333C9.17891 12.6641 9.02982 12.6103 8.90924 12.5138C8.78866 12.4173 8.70337 12.2837 8.66663 12.1337L8.06663 9.0004H7.9333L7.3333 12.1337C7.29656 12.2837 7.21126 12.4173 7.09068 12.5138C6.9701 12.6103 6.82102 12.6641 6.66663 12.6671H6.5333C6.35905 12.627 6.20672 12.5219 6.10755 12.3731C6.00838 12.2244 5.96989 12.0433 5.99996 11.8671L6.66663 8.6004V7.0004H4.3333C4.15648 7.0004 3.98692 6.93016 3.86189 6.80514C3.73687 6.68011 3.66663 6.51055 3.66663 6.33373C3.66663 6.15692 3.73687 5.98736 3.86189 5.86233C3.98692 5.73731 4.15648 5.66707 4.3333 5.66707H11.6666C11.8434 5.66707 12.013 5.73731 12.138 5.86233C12.2631 5.98736 12.3333 6.15692 12.3333 6.33373C12.3333 6.51055 12.2631 6.68011 12.138 6.80514C12.013 6.93016 11.8434 7.0004 11.6666 7.0004Z" /></g>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs><clipPath id="accessibility-solid-clip"><rect width="16" height="16" /></clipPath></defs>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { AccessibilitySolid };